<script>
</script>

<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_2629_14949)">
    <path
      d="M16.6667 7.5H9.16667C8.24619 7.5 7.5 8.24619 7.5 9.16667V16.6667C7.5 17.5871 8.24619 18.3333 9.16667 18.3333H16.6667C17.5871 18.3333 18.3333 17.5871 18.3333 16.6667V9.16667C18.3333 8.24619 17.5871 7.5 16.6667 7.5Z"
      stroke={$$props.color || '#1E95FF'}
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.16675 12.4998H3.33341C2.89139 12.4998 2.46746 12.3242 2.1549 12.0117C1.84234 11.6991 1.66675 11.2752 1.66675 10.8332V3.33317C1.66675 2.89114 1.84234 2.46722 2.1549 2.15466C2.46746 1.8421 2.89139 1.6665 3.33341 1.6665H10.8334C11.2754 1.6665 11.6994 1.8421 12.0119 2.15466C12.3245 2.46722 12.5001 2.89114 12.5001 3.33317V4.1665"
      stroke={$$props.color || '#1E95FF'}
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
  <defs>
    <clipPath id="clip0_2629_14949">
      <rect width="20" height="20" fill="white" />
    </clipPath>
  </defs>
</svg>
